import React, { useEffect } from "react";
import moment from "moment";
import SheWolf from "../images/corner/corner-shewolf.webp";
import { renderStrapiContent } from "../utils/contentfulOptions";
import Button from "../components/Button";
import FullPageLoader from "../components/FullPageLoader";

const Press = ({ info }) => {
  useEffect(() => {
    document.title = "Auburn Road - In The Press";
    return () => {
      document.title = "Auburn Road Vineyards";
    };
  }, []);

  if (!info) {
    return <FullPageLoader />;
  }

  return (
    <>
      <img className="corner-shewolf" src={SheWolf} alt="" />
      <div className="container content-page p-t-100">
        <section className="content-hero">
          <p className="content-hero__kicker">In the news</p>
          <h1 className="huge-text-no-quote content-hero__title">
            Nice things people say about us
          </h1>
          <p className="content-hero__intro">
            Press, features, and stories from around the region and beyond.
          </p>
        </section>

        <div className="content-list">
          {info.map((item, index) => {
            const { title, author, blurb, date, link } = item;
            return (
              <article
                key={item.id || index}
                className="content-list__item content-list__item--stripe"
              >
                {date && (
                  <p className="content-list__meta">
                    {moment(date).format("MMMM D, YYYY")}
                  </p>
                )}
                <h2 className="content-list__title">
                  <a
                    className="outgoing-link"
                    rel="noopener noreferrer"
                    target="_blank"
                    href={link}
                  >
                    {title}
                  </a>
                </h2>
                <div className="content-list__body">
                  {renderStrapiContent(blurb)}
                </div>
                <div className="content-list__footer">
                  {author ? (
                    <p className="content-list__author">by {author}</p>
                  ) : (
                    <span />
                  )}
                  <Button href={link} type="secondary" external>
                    Read Article
                  </Button>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default Press;
